import styles from "@/pages/Home/FeaturedServiceCard/FeaturedServiceCard.module.scss";
import ReactMarkdown from "react-markdown";
import {Button, ButtonType} from "@reapptor-apps/reapptor-react-components";
import Localizer from "@/localization/Localizer";
import React from "react";
import type {FeaturedService} from "@/models/cms/FeaturedService";

interface FeaturedServiceCardProps {
featuredService : FeaturedService | null;
showOnDesktopOrMobile: "desktop" | "mobile";
}
export const FeaturedServiceCard = ({ featuredService, showOnDesktopOrMobile }: FeaturedServiceCardProps) => {
  if (!featuredService) {
    return null;
  }
  
  const Header = () => (
    <div className={styles.featuredServiceHeader}>
      {featuredService.header}
    </div>
  ); 
  
  const Content = () => (
    <div className={styles.featuredServiceContent}>
      <ReactMarkdown>{featuredService.content ?? ''}</ReactMarkdown>
    </div>
  );

  const ButtonToService = () => featuredService.buttonText || featuredService.buttonLinkURL ? (
    <div className={styles.featuredServiceButtonContainer}>
      <Button className={styles.featuredServiceButton} type={ButtonType.Primary}
        label={featuredService.buttonText ?? Localizer.buttonGoToService}
        onClick={async () => { window.location.href = featuredService.buttonLinkURL ?? '' }}
      />
    </div>
  ) : null;
  
  const ImageContainer = () => (
    <div className={styles.featuredServiceImgContainer}>
      <img src={featuredService.image?.data?.attributes?.url} alt={featuredService.header ?? 'logo'} />
    </div>
  );

  return showOnDesktopOrMobile === "mobile" ? (
      <div className={styles.featuredServiceContainerForMobile}>
        <div className={styles.featuredServiceTextContainer}>
          <Header />
          <Content />
          <ButtonToService />
        </div>
        <ImageContainer />
      </div>
  ) : (
      <div className={styles.featuredServiceContainerForDesktop}>
        <div className={styles.featuredServiceHeaderContainer}>
          <div className={styles.featuredServiceHeader}>
            <Header />
          </div>
        </div>
        <div className={styles.featuredServiceTextAndButtonContainer}>
          <Content />
          <ButtonToService />
        </div>
        <ImageContainer />
      </div>
  );
};
